import { API_URLS, APP_URLS, extractErrorMessage } from "../../../config";

import { call, put } from "redux-saga/effects";
import { CallApi } from "./api/callApi";

export function* createRemainderSaga(action) {
    try {
        const data = action.payload;
        // console.log(data);


        const resp = yield call(CallApi.POST,
            API_URLS.REMAINDER.CREATE,
            data?.data,
            data?.token)
        // //console.log(resp);
        if (resp && resp?.status && resp?.status >= 200 && resp?.status < 300 && resp?.data && resp?.data?.success) {
            action && action.callbackSuccess && action.callbackSuccess(resp?.data);
        } else {
            action && action.callbackError && action.callbackError(resp?.data);
        }
    } catch (e) {
        action && action.callbackError && action.callbackError(e && e?.data ? e?.data : e);
    }
}


export function* updateReminderSaga(action) {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.PATCH,
            API_URLS.REMAINDER.UPDATE,
            data?.data,
            data?.token)
        // //console.log(resp);
        if (resp && resp?.status && resp?.status >= 200 && resp?.status < 300 && resp?.data && resp?.data?.success) {
            action && action.callbackSuccess && action.callbackSuccess(resp?.data);
        } else {
            action && action.callbackError && action.callbackError(resp?.data);
        }
    } catch (e) {
        action && action.callbackError && action.callbackError(e && e?.data ? e?.data : e);
    }
}


export function* getRemainderReportSaga(action) {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET,
            API_URLS.REMAINDER.REPORT,
            data?.data,
            data?.token)
        // //console.log(resp);
        if (resp && resp?.status && resp?.status >= 200 && resp?.status < 300 && resp?.data && resp?.data?.success) {
            action && action.callbackSuccess && action.callbackSuccess(resp?.data);
        } else {
            action && action.callbackError && action.callbackError(resp?.data);
        }
    } catch (e) {
        action && action.callbackError && action.callbackError(e && e?.data ? e?.data : e);
    }
}



export function* deleteReminderSaga(action) {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.DELETE,
            API_URLS.REMAINDER.DELETE,
            data?.data,
            data?.token)
        // //console.log(resp);
        if (resp && resp?.status && resp?.status >= 200 && resp?.status < 300 && resp?.data && resp?.data?.success) {
            action && action.callbackSuccess && action.callbackSuccess(resp?.data);
        } else {
            action && action.callbackError && action.callbackError(resp?.data);
        }
    } catch (e) {
        action && action.callbackError && action.callbackError(e && e?.data ? e?.data : e);
    }
}